import React from "react";
import Scaffold from "../../../widget/layouts/Scaffold";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import { BranchListContextProvider } from "../../../provider/branch/branch_list/BranchListContextProvider";
import BranchListing from "./widget/BranchListing";
import { MainBodyContainer } from "../../../widget/common/ui/MainContainer";
import BranchListActions from "./widget/BranchListActions";

const BranchListScreen = (props: { screenMobileView: boolean }) => {
  const screenMobileView: boolean = props.screenMobileView;

  return (
    <BranchListContextProvider>
      {screenMobileView === true ? (
        <Scaffold
          appBarTitle={AppTranslation.text("choose_preferred_branch")}
          appBarAction={<BranchListActions />}
          isModal={true}
        >
          <MainBodyContainer className="h-100">
            <BranchListing screenMobileView={screenMobileView} />
          </MainBodyContainer>
        </Scaffold>
      ) : (
        <BranchListing screenMobileView={screenMobileView} />
      )}
    </BranchListContextProvider>
  );
};

export default BranchListScreen;
//export const routeName: string = "/branch-list";
